import React, { useEffect, useState } from 'react';
import { MatomoProvider } from '@datapunt/matomo-tracker-react';
import PropTypes, { checkPropTypes } from 'prop-types';
import invokeWebAnalytics from './instance';

const TrackingProvider = (props) => {
  const { children, isinSite = defaultProps.isinSite } = props;
  checkPropTypes(TrackingProvider.propTypes, props, 'prop', TrackingProvider.name);
  const [instance, setInstance] = useState(null);

  useEffect(() => {
    (async () => {
      const newTracker = await invokeWebAnalytics(isinSite);
      setInstance(newTracker);
    })();
  }, [isinSite]);

  return <MatomoProvider value={instance}>{children}</MatomoProvider>;
};

TrackingProvider.propTypes = {
  children: PropTypes.node.isRequired,

  isinSite: PropTypes.bool
};

const defaultProps = {
  isinSite: true
};

export default TrackingProvider;
